// eslint-disable-line no-unused-expressions
import * as ReactDOM from 'react-dom';
import React from 'react';
import { loadCSS } from 'fg-loadcss';
//import './src/stylesheets/main.scss';
import { mainBus } from './src/core/EventBus';
import { IS_DESKTOP, IS_MOBILE, IS_TABLET } from './src/core/constant';
import { ARLoadingScreen } from './src/features/loading/components/ARLoadingScreen';
import './src/stylesheets/main.scss';
import PreLaunchLoader from './src/react/components/old/PreLaunchLoader';
import './src/il8n';
export function getUrlParam(para) {
  const queryString = require('query-string');
  return queryString.parse(window.location.search)[para];
}




const CSSFILES = [
  {
    url:
      process.env.NODE_ENV === 'production'
        ? `https://bitreel-viewer-scripts.s3.amazonaws.com/${process.env.REACT_APP_STAGE}/v2/static/css/main.css`
        : 'static/css/main.css',
    type: 'css',
  },
  {
    url: 'https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css',
    type: 'css',
  },
  {
    url: 'https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600&display=swap',
    type: 'css',
  }
];

const template = document.createElement('template');
template.innerHTML = `<slot></slot>`;

let bitreelFilesRemaining = {
  JS: 0,
  CSS: 0,
}; // set below
let stylesNodes = [];


export default class BitreelViewer extends HTMLElement {
  addMetaTag = () => {
    if (!this.metaTag) {
      this.metaTag = document.createElement('meta');
      this.metaTag.name = 'viewport';
      this.metaTag.setAttribute(
        'content',
        'width=device-width, initial-scale=1, shrink-to-fit=no, maximum-scale=1'
      );
    }
    
    //this.shadowRoot.appendChild(this.metaTag)
    document.getElementsByTagName('head')[0].appendChild(this.metaTag);
  };

  embedViewerFiles = (files, name) => {
    // TODO: show a loading spinner
    bitreelFilesRemaining[name] = files.length;
    return new Promise(async (resolve, reject) => {
      files.forEach(({ url, type, async }) => {
        switch (type) {
          case 'css':
            // if (!launched) {
            var stylesheet = loadCSS(url);
            onloadCSS(stylesheet, () => {
              stylesNodes.push(stylesheet);
              this.fileLoaded(resolve, { url, type })();
            });
            break;
          case 'js':
            let scriptElement = document.createElement('script');
            scriptElement.type = 'text/javascript';
            scriptElement.src = url;
            if (async) {
              scriptElement.async = true;
            }
            scriptElement.onload = this.fileLoaded(resolve, {
              url,
              type,
            });
            //this.shadowRoot.appendChild(scriptElement)
            document.getElementsByTagName('head')[0].appendChild(scriptElement);
            break;
          default:
            break;
        }
      });
    });
  };

  fileLoaded = (resolve, name) => {
    return () => {
      bitreelFilesRemaining[name] = bitreelFilesRemaining[name] - 1;
      if (!bitreelFilesRemaining[name]) {
        resolve(true);
      }
    };
  };


  fetchAttributes = () => {
    this.showroomId = this.getAttribute('showroomId');
    this.shellId = Number(this.getAttribute('shellid'));
    this.skipStats = this.getAttribute('skipStats');
    this.eacountry = this.getAttribute('eacountry')
    this.sessionId = getUrlParam('sessionId');
    this.productID = getUrlParam('productID');
    this.hostKey = getUrlParam('hostKey');
    this.requestHelpJoin = getUrlParam('requestHelpJoin');
    this.associateId = getUrlParam('associateId');
    this.sharedProductID = getUrlParam('sharedProductID');
    this.variantId = getUrlParam('variantId');
    this.easid = this.getAttribute('easessionid');
    this.shellVersionId = this.getAttribute('shellversion');
    this.spaceUUID = Number(getUrlParam('spaceUUID'));
    this.autoLaunch = this.getAttribute('autoLaunch');
    this.gamepad = this.hasAttribute('gamepad');
    this.debug = this.getAttribute('debug');
    mainBus.customElement = this
    mainBus.region = this.eacountry
    mainBus.eacountry = this.eacountry
  }

  launchWithAtrributes = async () => {

      if (
        !IS_DESKTOP &&
        typeof DeviceMotionEvent !== undefined &&
        typeof DeviceMotionEvent.requestPermission === 'function'
      ) {
        let response = await DeviceMotionEvent.requestPermission()
        if(response !== 'granted'){
          window.alert('need grant to access the experience, please refresh the page');
          return
        }
      }

    let bodyParent = document.body.parentElement;
      this.confirmParent = document.createElement('div');
      this.preloaderParent = document.createElement('div');
    bodyParent.appendChild(this.preloaderParent);
    bodyParent.appendChild(this.confirmParent);
      ReactDOM.render(
        // <Provider store={store}>
          <PreLaunchLoader/>,
        // </Provider>,
        this.preloaderParent
    );
      let startModule = await import('./src/index')
      if (this.sessionId) {
        startModule.default(this, { sessionId: this.sessionId })
        //this.launchViewer({ sessionId: this.sessionId });
      } else if (this.productID) {
        startModule.default(this, { productID: this.productID })
        //this.launchViewer({ productID: this.productID });
      } else if (this.sharedProductID) {
        startModule.default(this, { sharedProductID: this.sharedProductID })
        //this.launchViewer({ sharedProductID: this.sharedProductID });
      } else {
        startModule.default(this, {})
        //this.launchViewer({});
      }
  }

  launchWithoutAtrributes =  () => {
    this.viewerCTA.firstChild.onclick = async () => {
      if(window.bitreelLaunched){
        return
      }

      window.bitreelLaunched = true;
      if (
        !IS_DESKTOP &&
        typeof DeviceMotionEvent !== undefined &&
        typeof DeviceMotionEvent.requestPermission === 'function'
      ) {
        let response = await DeviceMotionEvent.requestPermission()
        if(response !== 'granted'){
          window.alert('need grant to access the experience, please refresh the page');
          return
        }
      }
      let bodyParent = document.body.parentElement;
      this.preloaderParent = document.createElement('div');
      bodyParent.appendChild(this.preloaderParent);
      ReactDOM.render(
        <PreLaunchLoader/>,
        this.preloaderParent
      );
      let startModule = await import('./src/index')
      startModule.default(this)
    };
    if(this.autoLaunch==="true" && !IS_MOBILE){
      this.viewerCTA.firstChild.click()
    }
  }

  async connectedCallback() {
    this.fetchAttributes()
    if (this.shadowRoot) {
      return
    }
    window.bitreelLaunched = false
    this.attachShadow({ mode: 'open' });
    this.viewerCTA = template.content.cloneNode(true);
    this.mountPoint = document.createElement('div');
    this.mountPoint.id = 'viewer-mount';
    this.addMetaTag();
    if(this.variantId && (IS_MOBILE||IS_TABLET)){
      let promise1 = this.embedViewerFiles(CSSFILES, 'CSS');
      let [res1] = await Promise.all([
        promise1,
      ]);
      document.body.appendChild(this.mountPoint);
      let loadingScreen = ReactDOM.render(
        <ARLoadingScreen variantId = {this.variantId}/>,
      this.mountPoint);
      return null
    }
    if (
      (this.sessionId || this.productID || this.sharedProductID) && this.spaceUUID === this.shellId && !window.bitreelLaunched) {
        // set a small random 10ms timeout prevent two shell with same id launch at the same time
        let timeout = Math.random() * 10
        setTimeout(() => {
          if(window.bitreelLaunched){
            return
          }
          window.bitreelLaunched = true;
          this.launchWithAtrributes();
        }, timeout);
    } else {
      this.launchWithoutAtrributes();
    }

    this.shadowRoot.appendChild(this.viewerCTA);
  }

  disconnectedCallback() {
  }




}

window.customElements.define('bitreel-viewer', BitreelViewer);

/*! onloadCSS. (onload callback for loadCSS) [c]2017 Filament Group, Inc. MIT License */
/* global navigator */
/* exported onloadCSS */
function onloadCSS(ss, callback) {
  var called;
  function newcb() {
    if (!called && callback) {
      called = true;
      callback.call(ss);
    }
  }
  if (ss.addEventListener) {
    ss.addEventListener('load', newcb);
  }
  if (ss.attachEvent) {
    ss.attachEvent('onload', newcb);
  }

  // This code is for browsers that don’t support onload
  // No support for onload (it'll bind but never fire):
  //	* Android 4.3 (Samsung Galaxy S4, Browserstack)
  //	* Android 4.2 Browser (Samsung Galaxy SIII Mini GT-I8200L)
  //	* Android 2.3 (Pantech Burst P9070)

  // Weak inference targets Android < 4.4
  if ('isApplicationInstalled' in navigator && 'onloadcssdefined' in ss) {
    ss.onloadcssdefined(newcb);
  }
}


